import Swiper, {Autoplay, Navigation, Thumbs, Zoom} from "swiper";

export default () => {
  let swiperProductThumbs = new Swiper(".product-gallery-thumbs", {
    spaceBetween: 12,
    slidesPerView: 4,
    freeMode: true,
    watchSlidesProgress: true,
  });

  let swiperProductTop = new Swiper(".product-gallery-top", {
    modules: [Thumbs, Navigation, Autoplay, Zoom],
    spaceBetween: 10,
    loop: true,
    loopedSlides: 6,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    thumbs: {
      swiper: swiperProductThumbs,
    },
    grabCursor: true,
    centeredSlides: true,
  });
}
